/* -----------Style Sheet------------ */
import "./styles.scss";

const HeaderComponent = ({ title, icon }) => {
  return <div className="breadcump_container"><i className={`m-r-10 bi bi-${icon}`}></i>{title}</div>;
};

export default HeaderComponent;
